import React from 'react'
import { Loading } from '@myxplor/ui'
import RecordDisplayList from '../../../ui/record-display-list'
import { validCCSClaimRange } from '../../../reports/helpers'
import { recordActionsToDisplay } from '../../../ui/gov-actions'
import { activeCase } from '../../helpers'
import withdrawClaim from './withdraw-claim'
import { CaseClaimHeading } from './heading'
import CreateClaim from './create-claim'

const level1 = [
  {
    key: 'ServiceProvision',
    label: 'Service Provision',
  },
  {
    key: 'ISCaseType',
    label: 'Case Type',
  },
  {
    key: 'ISPaymentType',
    label: 'Payment Type',
  },
]

const level2 = [
  {
    key: 'HoursClaimed',
    label: 'Hours claimed',
  },
  {
    key: 'GSTExclusiveAmount',
    label: 'GST Exclusive Amount',
  },
  {
    key: 'CreateDate',
    label: 'Date Created',
  },
  {
    key: 'CancelDate',
    label: 'Date Canceled',
  },
]

const actionsForRecord = ({ iss_case, refresh_iss_case_claim }) => ({ record }) => [
  withdrawClaim({ record, iss_case, refresh_iss_case_claim }),
]

const ISCaseClaim = ({ iss_case_claim, refresh_iss_case_claim, iss_case, gov_rego }) => {
  const { loading, data } = iss_case_claim

  if (loading) {
    return <Loading>Loading more details on the ISS Case Claim</Loading>
  }

  return (
    <RecordDisplayList
      name="ISS Case Claim"
      recordBadgesComponent={CaseClaimHeading}
      topContent={
        validCCSClaimRange({ week_start_date: gov_rego.start_date }) && activeCase(iss_case) ? (
          <CreateClaim
            issCase={iss_case}
            refresh_iss_case_claim={refresh_iss_case_claim}
            govRego={gov_rego}
          />
        ) : null
      }
      records={data}
      level1={level1}
      level2={level2}
      recordBase="gov_record"
      actionButtonsComponent={recordActionsToDisplay({
        actionsForRecord: actionsForRecord({
          iss_case,
          refresh_iss_case_claim,
        }),
      })}
      showRaw
    />
  )
}

export default ISCaseClaim



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/index.jsx